module.exports = "pegasus_template/assets/blocks/column-lp11-basic.png";